import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => {
  return (
    <header>
      <div id="top"></div>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top" id="header" aria-label="Offcanvas navbar large">
        <div className="container">
          <NavLink className="navbar-brand fw-semibold" to="/">Franklin</NavLink>
          <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar2" aria-controls="offcanvasNavbar2" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="offcanvas offcanvas-end text-bg-dark" tabIndex="-1" id="offcanvasNavbar2" aria-labelledby="offcanvasNavbar2Label">
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasNavbar2Label">Franklin</h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav justify-content-end flex-grow-1 gap-3">
                <li className="nav-item">
                  <NavLink className={({isActive}) => isActive ? "nav-link fw-semibold active" : "nav-link fw-semibold"} to="/">Home</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className={({isActive}) => isActive ? "nav-link fw-semibold active" : "nav-link fw-semibold"} to="/works">Works</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className={({isActive}) => isActive ? "nav-link fw-semibold active" : "nav-link fw-semibold"} to="/about">About</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className={({isActive}) => isActive ? "nav-link fw-semibold active" : "nav-link fw-semibold"} to="/blog">Blog</NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;